import { UserDisplayName, UserOptionLabel, ViperSelect } from "@/components";
import { useSuggestUsersQuery } from "@/services";
import { IUser } from "@/types/UserToken";
import { FormInstance, Select } from "antd";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
const { Option } = Select;

interface IProps {
  id: string;
  onChange: (value: Event) => void;
  existingProjectLeader?: IUser;
  name: string;
  formRef: FormInstance;
  value?: IUser;
  disabled: boolean;
  readOnly: boolean;
  allowClear: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ViperUserSearchSelect = (props: IProps, ...rest: any[]) => {
  const intl = useIntl();
  const [searchResultSet, setSearchResultSet] = useState(new Set<IUser>());
  const [searchQuery, setSearchQuery] = useState("");
  const handleInputChange = (value: Event) => props.onChange(value);
  const {
    data: userSuggestionsByQuery,
    isFetching: fetchingUserSuggestionsByQuery,
  } = useSuggestUsersQuery({ query: searchQuery }, { skip: !searchQuery });

  useEffect(() => {
    const results = new Set<IUser>();
    if (userSuggestionsByQuery) {
      for (let i = 0; i < userSuggestionsByQuery.length; i++) {
        const user = userSuggestionsByQuery[i].document as IUser;
        results.add(user);
      }
    }

    setSearchResultSet(results);
  }, [userSuggestionsByQuery]);

  useEffect(() => {
    if (!props.existingProjectLeader) return;

    const defaultSet = new Set<IUser>();
    defaultSet.add(props.existingProjectLeader);

    setSearchResultSet(defaultSet);
  }, [props.existingProjectLeader]);

  return (
    <ViperSelect
      data-test-id={`viper-user-select-input-${props.id}`}
      dataTestId={`viper-user-select-input-${props.id}`}
      onChange={handleInputChange}
      disabled={props.readOnly}
      loading={fetchingUserSuggestionsByQuery}
      onFetchSuggestions={setSearchQuery}
      allowMultipleSelections={false}
      placeholder={intl.formatMessage({ id: "general.search" })}
      allowClear={props.allowClear}
      optionLabelProp="label"
      value={props.value?.toString()}
      customOptions={Array.from(searchResultSet).map((user) => (
        <Option
          key={user.id}
          label={
            <UserDisplayName
              displayName={user.displayName ?? ""}
              userAccountEnabled={user.azureAdAccountEnabled}
            />
          }
        >
          <UserOptionLabel
            displayName={user.displayName ?? ""}
            department={user.department}
            email={user.email}
            jobTitle={user.jobTitle}
          />
        </Option>
      ))}
      {...rest}
    />
  );
};
